export const USER_REGISTER_EVENT = 'USER_REGISTER_EVENT';
export const USER_PLAN_PUSHED_EVENT = 'USER_PLAN_PUSHED_EVENT';
export const FEATURE_TESTS_PUSHED_EVENT = 'FEATURE_TESTS_PUSHED_EVENT';
export const BATCH_INITIATE_FLOW_EVENT = 'BATCH_INITIATE_FLOW_EVENT';
export const BATCH_SHOW_RATES_EVENT = 'BATCH_SHOW_RATES_EVENT';
export const BATCH_PURCHASED_EVENT = 'BATCH_PURCHASED_EVENT';
export const STORE_CONNECTION_SUCCESS_EVENT = 'STORE_CONNECTION_SUCCESS_EVENT';
export const USER_ADDED_ADDRESS = 'USER_ADDED_ADDRESS';
export const USER_ADDED_CREDITCARD = 'USER_ADDED_CREDITCARD';
export const CARRIER_REGISTRATION_SUCCESS = 'CARRIER_REGISTRATION_SUCCESS';
export const CARRIER_CONNECT_SUCCESS = 'CARRIER_CONNECT_SUCCESS';
export const UPS_MASTER_REGISTRATION_SUCCESS = 'UPS_MASTER_REGISTRATION_SUCCESS';
export const CONNECTED_STORE_SUCCESS = 'CONNECTED_STORE_SUCCESS';
export const ORDERS_COUNT = 'ORDERS_COUNT';
export const ACTIVATION_DATA = 'ACTIVATION_DATA';
export const SET_SENDER_ADDRESS_ONBOARDING = 'SET_SENDER_ADDRESS_ONBOARDING';
export const FIRST_LABEL_PURCHASED = 'FIRST_LABEL_PURCHASED';
export const FIRST_ORDER_ADDED = 'FIRST_ORDER_ADDED';
export const FIRST_STORE_CONNECTED = 'FIRST_STORE_CONNECTED';
export const SET_ACCOUNT_INFO_ONBOARDING = 'SET_ACCOUNT_INFO_ONBOARDING';
export const CSV_IMPORT_SUCCESS = 'CSV_IMPORT_SUCCESS';
export const SET_FIRST_LABEL_FORMAT = 'SET_FIRST_LABEL_FORMAT';
export const SET_FIRST_CARRIER = 'SET_FIRST_CARRIER';
export const SET_FIRST_CREDIT_CARD = 'SET_FIRST_CREDIT_CARD';
export const SET_FIRST_PACKAGE_TEMPLATE = 'SET_FIRST_PACKAGE_TEMPLATE';
export const SET_PRIMARY_CARRIER = 'SET_PRIMARY_CARRIER';
export const SEVENDFLR = '7DFLR';
export const USER_SIGNED_IN = 'USER_SIGNED_IN';
